var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottomDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 557,
    viewBox: "0 0 574 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.708 339.628C602.402 570.975 413.722 703.509 251.656 506.141C27.1048 627.782 -97.6304 433.859 94.9403 262.501C-18.7528 31.154 169.927 -101.379 331.993 95.9879C556.544 -25.6529 681.279 168.27 488.708 339.628Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomDecor);
export default __webpack_public_path__ + "static/media/bottom-decor.63a824938a21d3d11410d8fddbaafd8e.svg";
export { ForwardRef as ReactComponent };